// components/DoctorNameDisplay.js
import React, { useState } from 'react';
import {
  Box,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Chip,
  Tooltip
} from '@mui/material';
import {
  Person as PersonIcon,
  Edit as EditIcon,
  Logout as LogoutIcon
} from '@mui/icons-material';
import { useDoctor } from '../contexts/DoctorContext';

const DoctorNameDisplay = ({ onEditDoctor }) => {
  const { doctorName, clearDoctorName } = useDoctor();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEditDoctor = () => {
    handleClose();
    onEditDoctor();
  };

  const handleLogout = () => {
    handleClose();
    clearDoctorName();
  };

  if (!doctorName) {
    return (
      <Chip
        icon={<PersonIcon />}
        label="Médecin non défini"
        color="warning"
        variant="outlined"
        onClick={handleEditDoctor}
        clickable
      />
    );
  }

  return (
    <Box>
      <Tooltip title="Cliquer pour les options">
        <Chip
          icon={<PersonIcon />}
          label={doctorName}
          color="primary"
          variant="filled"
          onClick={handleClick}
          clickable
        />
      </Tooltip>
      
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem onClick={handleEditDoctor}>
          <EditIcon sx={{ mr: 1 }} />
          Changer le nom
        </MenuItem>
        <MenuItem onClick={handleLogout}>
          <LogoutIcon sx={{ mr: 1 }} />
          Déconnexion
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default DoctorNameDisplay;
